module.exports = __webpack_public_path__ + "static/img/4fcde9a1-67e7-4c56-ad4a-5023c043e62d.3dfe88cb.png";